/* =====================================================================
   Chilly's Times – welcome offer popup
   Markup and settings: snippets/ct-welcome-popup.liquid

   When it opens
   - Exit attempt: the pointer leaves through the top of the window (towards
     the tabs, address bar or close button), or the shopper switches to another
     tab/app and comes back. Counts after 5 seconds on the page.
   - No activity: no mouse, touch, key or scroll for the set time (30 s default).

   When it never opens
   - Basket drawer open, or touched in the last 20 seconds.
   - While scrolling (and for a moment after).
   - Menu or search open, someone typing in a field, another dialog showing.
   - Already shown this visit, or closed in the last 14 days (setting).
   - Already subscribed: remembered in this browser (storage + cookie), after
     signing up here or in any newsletter form, or a logged-in customer with
     marketing consent (the snippet isn't even rendered for them).

   Preview: add ?popup=1 to any URL. Clear the memory: ?popup=reset
   ===================================================================== */
(function () {
  "use strict";
  var root = document.getElementById("ctXp");
  if (!root || root.dataset.ready) return;
  root.dataset.ready = "1";

  var C = {};
  try { C = JSON.parse(root.querySelector("[data-xp-config]").textContent); } catch (e) {}
  var IDLE_MS = Math.max(5, +C.idleSeconds || 30) * 1000;
  var ARM_MS = 5000, SCROLL_QUIET_MS = 1200, CART_QUIET_MS = 20000, RETURN_AWAY_MS = 3000;
  var SNOOZE_MS = Math.max(1, +C.snoozeDays || 14) * 864e5;
  var K_SUB = "ct_xp_sub", K_SNOOZE = "ct_xp_snooze", K_SEEN = "ct_xp_seen";

  /* ---------- Memory: localStorage + cookie, both optional ---------- */
  var mem = {};
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return mem[k] || null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { mem[k] = v; } }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} delete mem[k]; }
  function ckGet(k) { var m = document.cookie.match(new RegExp("(?:^|; )" + k + "=([^;]*)")); return m ? decodeURIComponent(m[1]) : null; }
  function ckSet(k, v, ms) { try { document.cookie = k + "=" + encodeURIComponent(v) + "; max-age=" + Math.round(ms / 1000) + "; path=/; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : ""); } catch (e) {} }
  function ckDel(k) { try { document.cookie = k + "=; max-age=0; path=/"; } catch (e) {} }

  function isSubscribed() { return lsGet(K_SUB) === "1" || ckGet(K_SUB) === "1"; }
  function markSubscribed() { lsSet(K_SUB, "1"); ckSet(K_SUB, "1", 3 * 365 * 864e5); lsDel(K_SNOOZE); ckDel(K_SNOOZE); }
  function snoozedUntil() { return Math.max(+lsGet(K_SNOOZE) || 0, +ckGet(K_SNOOZE) || 0); }
  function snooze() { var t = Date.now() + SNOOZE_MS; lsSet(K_SNOOZE, String(t)); ckSet(K_SNOOZE, String(t), SNOOZE_MS); }
  function eligible() { return !isSubscribed() && Date.now() >= snoozedUntil() && ssGet(K_SEEN) !== "1"; }
  window.ctWelcome = { markSubscribed: markSubscribed };

  /* ---------- Elements ---------- */
  var card = root.querySelector(".xp__card"), form = root.querySelector("form"),
      email = root.querySelector('input[type="email"]'), msg = root.querySelector(".xp__msg"),
      submit = root.querySelector("[data-xp-submit]"), ask = root.querySelector("[data-xp-ask]"),
      done = root.querySelector("[data-xp-done]"), eyebrow = root.querySelector("[data-xp-eyebrow]"),
      img = root.querySelector(".xp__media img");

  /* ---------- URL switches and returns from Shopify ---------- */
  var params = new URLSearchParams(location.search), preview = params.get("popup");
  if (preview === "reset") { lsDel(K_SUB); ckDel(K_SUB); lsDel(K_SNOOZE); ckDel(K_SNOOZE); ssDel(K_SEEN); }
  /* Any newsletter form on the store that went through (footer, page sections) */
  var posted = params.get("customer_posted") === "true";
  if (posted) markSubscribed();
  var fromPopup = location.hash === "#ctXpForm";
  var serverError = root.querySelector("[data-xp-server-error]");

  /* ---------- Activity tracking ---------- */
  var startedAt = Date.now(), lastActive = Date.now(), lastScroll = 0, cartTouched = 0;
  function active() { lastActive = Date.now(); }
  function onScroll() { lastScroll = Date.now(); lastActive = lastScroll; }
  ["pointerdown", "pointermove", "keydown", "wheel", "touchstart", "touchmove", "input"].forEach(function (t) {
    window.addEventListener(t, active, { passive: true, capture: true });
  });
  /* Page scrolling only: carousels that move by themselves must not count as the shopper scrolling */
  window.addEventListener("scroll", onScroll, { passive: true });

  /* Basket drawer: open, or used recently */
  var cart = document.getElementById("cart");
  function cartOpen() { return !!(cart && (cart.classList.contains("is-open") || cart.getAttribute("aria-hidden") === "false")) || document.body.classList.contains("ct-cart-locked"); }
  if (cart) {
    new MutationObserver(function () { cartTouched = Date.now(); }).observe(cart, { attributes: true, attributeFilter: ["class", "aria-hidden"] });
    ["pointerdown", "keydown", "focusin", "input", "change"].forEach(function (t) { cart.addEventListener(t, function () { cartTouched = Date.now(); }, true); });
  }
  document.addEventListener("ct:cart:updated", function () { cartTouched = Date.now(); });
  document.addEventListener("submit", function (e) { if (e.target && /\/cart\/add/.test(e.target.action || "")) cartTouched = Date.now(); }, true);

  function visible(el) { return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== "hidden"); }
  /* Showing on screen right now: rendered, inside the viewport, not transparent */
  function onScreen(el) {
    if (!visible(el)) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2 || r.right <= 0 || r.bottom <= 0 || r.left >= innerWidth || r.top >= innerHeight) return false;
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) if (+getComputedStyle(n).opacity < 0.05) return false;
    return true;
  }
  /* Returns a reason string when now is a bad moment, or "" when it is fine */
  function blocked() {
    if (document.visibilityState !== "visible") return "hidden";
    if (cartOpen()) return "cart";
    if (Date.now() - cartTouched < CART_QUIET_MS) return "cart-recent";
    if (Date.now() - lastScroll < SCROLL_QUIET_MS) return "scrolling";
    var d = document.getElementById("drawer"); if (d && d.classList.contains("is-open")) return "menu";
    var ms = document.getElementById("ct-mobile-search"); if (ms && !ms.hidden) return "search";
    var sg = document.getElementById("ct-home-search-suggestions"); if (sg && !sg.hidden && onScreen(sg)) return "search";
    var a = document.activeElement;
    if (a && a !== document.body && !root.contains(a) && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) return "typing";
    if (document.querySelector("dialog[open]")) return "dialog";
    var others = document.querySelectorAll('[aria-modal="true"]');
    var menu = document.getElementById("drawer");
    for (var i = 0; i < others.length; i++) {
      var o = others[i];
      if (root.contains(o) || (cart && cart.contains(o)) || (menu && menu.contains(o))) continue;  /* checked above */
      if (onScreen(o)) return "dialog";
    }
    var pc = document.getElementById("shopify-pc__banner"); if (onScreen(pc)) return "cookie-banner";
    return "";
  }

  /* ---------- Open / close ---------- */
  var isOpen = false, lastFocus = null;
  var coarse = window.matchMedia("(hover: none), (pointer: coarse)").matches;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");

  function tryOpen(reason, attempt) {
    if (isOpen || !eligible()) return false;
    var b = blocked();
    if (b) {
      /* An exit attempt during a scroll: give it one more chance once things settle */
      if (b === "scrolling" && reason !== "idle" && (attempt || 0) < 2) setTimeout(function () { tryOpen(reason, (attempt || 0) + 1); }, SCROLL_QUIET_MS);
      return false;
    }
    open(reason);
    return true;
  }

  function open(reason) {
    if (isOpen) return;
    isOpen = true; stopTriggers();
    if (reason !== "preview") ssSet(K_SEEN, "1");
    if (eyebrow) eyebrow.textContent = (reason === "exit" || reason === "return") ? eyebrow.dataset.exit : eyebrow.dataset.idle;
    if (img) img.loading = "eager";
    lastFocus = document.activeElement;
    root.hidden = false; root.dataset.reason = reason;
    document.documentElement.classList.add("xp-lock");
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add("is-in"); }); });
    /* Phones: focus the dialog, not the field, so the keyboard doesn't jump up uninvited */
    setTimeout(function () { try { ((coarse || !ask || ask.hidden) ? card : email).focus({ preventScroll: true }); } catch (e) {} }, 60);
    document.addEventListener("keydown", onKey, true);
    track("ct_welcome_popup_view", { trigger: reason });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    if (!isSubscribed() && root.dataset.reason !== "preview") snooze();
    root.classList.remove("is-in");
    document.removeEventListener("keydown", onKey, true);
    setTimeout(function () { root.hidden = true; document.documentElement.classList.remove("xp-lock"); }, reduce.matches ? 0 : 300);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function focusables() {
    return Array.prototype.filter.call(card.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]),[tabindex]:not([tabindex="-1"])'), function (el) { return el.getClientRects().length > 0; });
  }
  function onKey(e) {
    if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key !== "Tab") return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1], cur = document.activeElement;
    if (!card.contains(cur)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && (cur === first || cur === card)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
  }
  root.addEventListener("click", function (e) { if (e.target.closest("[data-xp-close]")) close(); });

  /* ---------- Email check with a nudge for common typos ---------- */
  var DOMAINS = ["gmail.com", "googlemail.com", "hotmail.co.uk", "hotmail.com", "outlook.com", "live.co.uk", "yahoo.co.uk", "yahoo.com", "icloud.com", "me.com", "btinternet.com", "sky.com", "aol.com", "virginmedia.com", "talktalk.net"];
  function dist(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    if (Math.abs(m - n) > 2) return 9;
    for (i = 0; i <= m; i++) d[i] = [i];
    for (j = 0; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) for (j = 1; j <= n; j++) {
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
    return d[m][n];
  }
  function suggest(v) {
    var at = v.lastIndexOf("@"); if (at < 1) return null;
    var dom = v.slice(at + 1).toLowerCase(); if (DOMAINS.indexOf(dom) > -1) return null;
    var best = null, bd = 3;
    DOMAINS.forEach(function (x) { var k = dist(dom, x); if (k < bd) { bd = k; best = x; } });
    return best && bd <= 2 ? v.slice(0, at + 1) + best : null;
  }
  function setError(text, fix) {
    msg.textContent = text || "";
    email.setAttribute("aria-invalid", text || fix ? "true" : "false");
    if (fix) {
      var b = document.createElement("button"); b.type = "button"; b.textContent = fix;
      b.addEventListener("click", function () { email.value = fix; setError(""); email.focus(); });
      msg.textContent = "Did you mean "; msg.appendChild(b); msg.appendChild(document.createTextNode("?"));
    }
  }
  function busy(on) { submit.classList.toggle("is-busy", on); if (on) submit.setAttribute("aria-busy", "true"); else submit.removeAttribute("aria-busy"); }
  email.addEventListener("input", function () { if (email.getAttribute("aria-invalid") === "true") setError(""); });

  var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, nudged = "";
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var v = email.value.trim(); email.value = v;
    if (!v) { setError("Enter your email address to get your code."); email.focus(); return; }
    if (!RE.test(v) || !email.checkValidity()) { setError("That email doesn’t look quite right. Try something like name@example.co.uk."); email.focus(); return; }
    var fix = suggest(v);
    if (fix && nudged !== v) { nudged = v; setError("", fix); email.focus(); return; }  /* ask once, then accept */
    setError(""); busy(true);
    ssSet("ct_xp_email", v);

    var action = (form.getAttribute("action") || "/contact").split("#")[0];
    fetch(action, { method: "POST", body: new FormData(form), credentials: "same-origin", headers: { Accept: "text/html" } })
      .then(function (r) {
        /* Shopify's spam check: let the real form go through it, we pick up again on return */
        if (/\/challenge/.test(r.url)) { form.submit(); return; }
        if (/[?&]customer_posted=true/.test(r.url)) return success(v);
        return r.text().then(function (html) {
          var err = null;
          try {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var el = doc.querySelector("#ctXpForm [data-xp-server-error]");
            err = el ? el.textContent.trim() : null;
          } catch (x) {}
          if (err && !/already|taken/i.test(err)) { busy(false); setError(err); email.focus(); return; }
          if (!r.ok) throw new Error(r.status);
          success(v);
        });
      })
      .catch(function () { busy(false); setError("Sorry, that didn’t go through. Please check your connection and try again."); });
  });

  function success(v) {
    markSubscribed(); busy(false);
    var who = root.querySelector("[data-xp-done-email]"); if (who && v) who.textContent = v;
    ask.hidden = true; done.hidden = false;
    card.setAttribute("aria-labelledby", "ctXpDoneTitle");
    var t = document.getElementById("ctXpDoneTitle"); if (t) try { t.focus({ preventScroll: true }); } catch (e) {}
    track("ct_welcome_popup_signup", { trigger: root.dataset.reason || "" });
  }

  var copyBtn = root.querySelector("[data-xp-copy]");
  if (copyBtn) copyBtn.addEventListener("click", function () {
    var codeEl = root.querySelector("[data-xp-code]"), code = codeEl.textContent.trim(),
        label = copyBtn.querySelector("span"), status = root.querySelector("[data-xp-copy-status]");
    function ok() { copyBtn.classList.add("is-done"); label.textContent = "Copied"; if (status) status.textContent = "Code copied"; setTimeout(function () { copyBtn.classList.remove("is-done"); label.textContent = "Copy"; }, 2200); }
    function fallback() {
      var r = document.createRange(); r.selectNodeContents(codeEl);
      var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
      try { if (document.execCommand("copy")) ok(); else label.textContent = "Select and copy"; } catch (e) { label.textContent = "Select and copy"; }
    }
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(ok, fallback); else fallback();
  });

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  /* ---------- Triggers ---------- */
  var idleTimer = null, hiddenAt = 0, triggersOn = false;
  function onMouseOut(e) {
    if (e.relatedTarget || e.toElement) return;
    if (e.clientY > 10) return;                         /* only through the top edge */
    if (Date.now() - startedAt < ARM_MS) return;
    tryOpen("exit");
  }
  function onVisibility() {
    if (document.visibilityState === "hidden") { hiddenAt = Date.now(); return; }
    var away = hiddenAt ? Date.now() - hiddenAt : 0; hiddenAt = 0;
    active();                                            /* coming back counts as activity */
    if (C.exitIntent && away >= RETURN_AWAY_MS && Date.now() - startedAt >= ARM_MS + away)
      setTimeout(function () { tryOpen("return"); }, 700);
  }
  function idleTick() {
    if (!triggersOn) return;
    if (!eligible()) { stopTriggers(); return; }       /* signed up elsewhere on the page */
    var quiet = Date.now() - lastActive;
    if (quiet >= IDLE_MS && document.visibilityState === "visible") {
      if (!tryOpen("idle")) active();                    /* bad moment: start the count again */
    }
    if (triggersOn) idleTimer = setTimeout(idleTick, Math.max(250, Math.min(1000, IDLE_MS - (Date.now() - lastActive))));
  }
  function startTriggers() {
    if (triggersOn) return; triggersOn = true;
    if (C.exitIntent && !coarse) document.addEventListener("mouseout", onMouseOut);
    document.addEventListener("visibilitychange", onVisibility);
    idleTimer = setTimeout(idleTick, 1000);
    /* Warm the picture once the page has settled, so it is ready when the popup opens */
    if (img) setTimeout(function () { if ("requestIdleCallback" in window) requestIdleCallback(function () { img.loading = "eager"; }); else img.loading = "eager"; }, Math.min(IDLE_MS - 3000, 8000));
  }
  function stopTriggers() {
    triggersOn = false; clearTimeout(idleTimer);
    document.removeEventListener("mouseout", onMouseOut);
    document.removeEventListener("visibilitychange", onVisibility);
  }

  /* Console helper for checking set-up: ctWelcome.status() */
  window.ctWelcome.status = function () { return { subscribed: isSubscribed(), snoozedUntil: snoozedUntil() ? new Date(snoozedUntil()).toString() : null, shownThisVisit: ssGet(K_SEEN) === "1", blockedBy: blocked() || null, idleFor: Math.round((Date.now() - lastActive) / 1000) + " s", triggersOn: triggersOn }; };
  window.ctWelcome.open = function () { open("preview"); };

  /* ---------- Start ---------- */
  if (fromPopup && posted) { setTimeout(function () { open("return-signup"); success(ssGet("ct_xp_email") || ""); }, 300); return; }
  if (fromPopup && serverError) { setTimeout(function () { open("return-error"); email.setAttribute("aria-invalid", "true"); email.focus(); }, 300); return; }
  if (preview === "1") { setTimeout(function () { open("preview"); }, 300); return; }
  if (root.hasAttribute("data-design-mode")) { if (C.editorPreview) open("preview"); return; }
  if (eligible()) startTriggers();
})();
